import { reportingApiFetch, reportingPath } from "@/lib/reportingApi";

/** @param {{ startDate?: string, endDate?: string } | null | undefined} range */
function rangeQuery(range) {
  const sp = new URLSearchParams();
  if (range?.startDate && range?.endDate) {
    sp.set("start_date", range.startDate);
    sp.set("end_date", range.endDate);
  } else {
    sp.set("days", "7");
  }
  return `?${sp.toString()}`;
}

/** @param {{ startDate?: string, endDate?: string }} range @param {RequestInit} [init] */
export function fetchTicketDashboard(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/human-agent/ticket-dashboard")}${rangeQuery(range)}`, init);
}
